import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'common/hooks/state';
import { RootState } from 'common/store/store';
import { DoqitLogo } from 'common/designSystem/iconComponents';
import { linkPath } from 'common/constants';
import { useGetProfilePictureQuery } from 'features/Sharing/SharingService';
import { parseObjectPropertiesToCamelCase } from 'common/utils/helpers';
import { StickyHeaderRow } from 'common/components/StickyHeaderRow';

type Props = {
  onLogoTap?: () => void;
  // Travel down the page with the scroll, like the Back rows elsewhere.
  // Reminders and Sharing only: Home keeps a header that scrolls away.
  sticky?: boolean;
};

export const MobileTopHeader = ({ onLogoTap, sticky = false }: Props) => {
  const navigate = useNavigate();
  const user = useAppSelector((s: RootState) => s.auth.user);
  const userProfileData = parseObjectPropertiesToCamelCase(user?.user || user);
  const email = userProfileData?.email;
  const firstName = user?.user?.first_name || user?.first_name;
  const { data: profilePictureData } = useGetProfilePictureQuery();
  const profilePicture: string | null = profilePictureData?.data?.profile_picture || null;
  const avatarInitial = (firstName?.charAt(0) || email?.charAt(0) || '?').toUpperCase();
  const displayName = firstName || 'Welcome';

  const goToMenu = () => navigate(linkPath.menuBar);

  const Row = sticky ? StickyHeaderRow : 'div';

  return (
    <Row className="logo-date flex justify-between items-center mt-6">
      {onLogoTap ? (
        <button
          type="button"
          className="order-frst"
          onClick={onLogoTap}
        >
          <DoqitLogo
            className="w-[101px] h-[57px]"
            data-cy="doqit-logo"
          />
        </button>
      ) : (
        <div className="order-frst">
          <DoqitLogo
            className="w-[101px] h-[57px]"
            data-cy="doqit-logo"
          />
        </div>
      )}
      {/* Generous hit area covering both the display name and the avatar
          so a finger tap anywhere on the right of the header opens /menu. */}
      <button
        type="button"
        onClick={goToMenu}
        className="flex items-center gap-3 bg-transparent border-0 cursor-pointer -mr-2 px-2 py-2 rounded-lg active:bg-black/5"
        data-cy="user-greeting"
        data-tour="avatar"
        aria-label="Open menu"
      >
        <span
          style={{
            color: '#39264F', fontWeight: 500, fontSize: 16, letterSpacing: 0.5,
          }}
        >
          {displayName}
        </span>
        <div
          className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center"
          style={{
            background: profilePicture
              ? '#EEEBF2'
              : 'linear-gradient(144.12deg, #AB72ED 11.61%, #744DA1 100%)',
            border: '1px solid rgba(57, 38, 79, 0.15)',
          }}
          data-cy="user-avatar"
        >
          {profilePicture ? (
            <img
              src={profilePicture}
              alt={`${displayName} avatar`}
              className="w-full h-full object-cover"
            />
          ) : (
            <span aria-hidden="true" style={{ color: '#FFFFFF', fontWeight: 600, fontSize: 16 }}>
              {avatarInitial}
            </span>
          )}
        </div>
      </button>
    </Row>
  );
};

export default MobileTopHeader;
